const initialState = {
    user: null,
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_USER':
            return { ...state, user: action.payload };
        case 'UPDATE_USER_CHAT':
            return {
                ...state,
                user: {
                    ...state.user,
                    chat: action.payload,
                }
            };
        default:
            return state;
    }
};

export default reducer;
